import React, { useState } from "react";
/* react-web-components */
import { Input, SelectInput, Messages, DatePicker, InputHelp } from '@sogei/react-web-components-catalog';
/* css */
import '../../assets/css/iscrizione/iscrizione.css'
import {listaNascitaIndir} from '../../config/constants'


const ContactInformation = (props) => {
    const [ErrorAdd, setErrorAdd] = useState(false);
    const [ErrorAddS, setErrorAddS] = useState(false);
    const [Information, setInformation] = useState(props.Information);
    const extraProps = {
        disabled: props.review,
    }
    const extraProps3 = {
        disabled: props.review,
        maxLength: '15'
    }
    const extraProps2 = {
        description: 'Relationship with the company: Please fill notes about relationship with the company (i.e., CEO, legal representative, secretary, ...)',
        content: 'Help sul campo...',
        disabled: props.review,
        maxLength: 200
        //autoFocus: true,
        //isMandatory: true
    }

    const optionList2 = [{ optionValue: 'Mr.', optionLabel: 'Mr.' }, { optionValue: 'Ms.', optionLabel: 'Ms.' },]
    const optionList3 = [{ optionValue: 'M', optionLabel: 'M' }, { optionValue: 'F', optionLabel: 'F' },]
    const { ErrorTelefono, ErrorMessageText, ErrorCognome, ErrorNome, ErrorMessageText2, error,
        ErrorMessageText3, ErrorDate, ErrorMessageText15, ErrorCountryBirth, ErrorMessageText16,
        ErrorEmail3, ErrorEmail4, ErrorMessageText17, ErrorMessageText18, ErrorRelationship, ErrorMessageText19 } = props.infoStore


    const handleChange = (e, index) => {
        const { name, value, id } = e.target;
        const _tempCosts = [...Information];
        _tempCosts[index][name] = value;

        setInformation(_tempCosts);
        props.Information.replace(_tempCosts)

        if (name === 'azcng8A_CN_PHONE_NUM_EL') {
            props.infoStore.validateNumberTel(value)
        }
        if (name === 'azcng8A_CN_FIRST_NAME_EL') {
            props.infoStore.validateNome(value)
        }
        if (name === 'azcng8A_CN_LAST_NAME_EL') {
            props.infoStore.validateCognome(value)
        }
        if (name === 'azcng8A_CN_STATO_NASC_EL') {
            props.infoStore.validateCountryBirth(value)
        }
        if (name === 'azcng8A_CN_EMAIL_EL') {
            props.infoStore.validateEmail2(value)
        }
        /* if (name === 'azcng8A_CN_CONFERMA_EMAIL_EL') {
            props.infoStore.validateConfirmEmail2(value)
        } */
        if (name === 'azcng8A_CN_RELATIONSHIP_EL') {
            props.infoStore.validateRelationship(value)
        }
    };

    const verifyAdd = () => {
        const _tempCosts = [...Information];
        let lastElement = _tempCosts[_tempCosts.length - 1]
        if (lastElement.azcng8A_CN_FIRST_NAME_EL != '') {
            let newData = {};
            for (var k in lastElement) {
                if (lastElement[k] === '')
                    newData[k] = lastElement[k];
            }
            if (newData.azcng8A_CN_MIDDLE_NAME_EL === '') {
                delete newData.azcng8A_CN_MIDDLE_NAME_EL;
            }
            if (newData.azcng8A_CN_TITLE_EL === '') {
                delete newData.azcng8A_CN_TITLE_EL;
            }
            if ((Object.keys(newData).length == 0)) {
                console.log(newData);
                if (_tempCosts.length < 3) {
                    setErrorAdd(false)
                    addNewOrg();
                }
            }
        } else {
            setErrorAdd(true)
        }
    }

    const addNewOrg = () => {
        setInformation(prevCosts => [...prevCosts, {
            azcng8A_CN_TITLE_EL: '',
            azcng8A_CN_FIRST_NAME_EL: '',
            azcng8A_CN_MIDDLE_NAME_EL: '',
            azcng8A_CN_LAST_NAME_EL: '',
            azcng8A_CN_STATO_NASC_EL: '',
            azcng8A_CN_DATA_NASC_EL: '',
            azcng8A_CN_SEX_EL: '',
            azcng8A_CN_PHONE_NUM_EL: '',
            azcng8A_CN_EMAIL_EL: '',
            azcng8A_CN_RELATIONSHIP_EL: ''
        }]);

    };

    const removeSite = (item, i) => {
        const _tempCosts = [...Information];
        let filtered = _tempCosts.filter(function (el) { return ((el.azcng8A_CN_FIRST_NAME_EL != item.azcng8A_CN_FIRST_NAME_EL)) });

        if ((i > 0 && filtered.length > 0)) {
            setInformation(filtered);
        } else if (i == 0 && filtered.length === 1) {
            setInformation(filtered);
        } else {
            setInformation(filtered);
            setInformation(prevCosts => [...prevCosts, {
                azcng8A_CN_TITLE_EL: '',
                azcng8A_CN_FIRST_NAME_EL: '',
                azcng8A_CN_MIDDLE_NAME_EL: '',
                azcng8A_CN_LAST_NAME_EL: '',
                azcng8A_CN_STATO_NASC_EL: '',
                azcng8A_CN_DATA_NASC_EL: '',
                azcng8A_CN_SEX_EL: '',
                azcng8A_CN_PHONE_NUM_EL: '',
                azcng8A_CN_EMAIL_EL: '',
                azcng8A_CN_RELATIONSHIP_EL: ''
            }]);;
        }
    }

    const handleChangeData2 = (e, index) => {
        const _tempCosts = [...Information];
        _tempCosts[index]['azcng8A_CN_DATA_NASC_EL'] = e;
        if (!/^(3[01]|[12][0-9]|0[1-9])\/(1[0-2]|0[1-9])\/[0-9]{4}$/.test(e)) {
            setErrorAddS(true)
        } else {
            setErrorAddS(false)
        }

        setInformation(_tempCosts);
        props.Information.replace(_tempCosts)
    }

    return (
        <>
            {Information.map((item, index) => (
                <div key={index}>
                    {(index != 0) ? <div className="row">
                        <div className="col-1" />
                        <div className="col-5">
                            <hr className="borderSeparated"></hr>
                        </div>
                    </div> : ''}
                    <div className="row">
                        <div className="col-1 ml-4">
                            <SelectInput id='title' value={item.azcng8A_CN_TITLE_EL} name={"azcng8A_CN_TITLE_EL"} dimension='sm' label='Title' firstEmptyOption={true}
                                optionList={optionList2} event={{ onChange: (e) => handleChange(e, index) }} extraProps={extraProps} />
                        </div>

                        <div className="col-2">
                            <div className="d-flex">
                                
                                <Input name={"azcng8A_CN_FIRST_NAME_EL"} id='FirstName' label='First Name' value={item.azcng8A_CN_FIRST_NAME_EL} error={error}
                                    inputClass={['mr-5']} labelClass={['requiredLabel']} event={{ onChange: (e) => handleChange(e, index) }} extraProps={extraProps} />
                            </div>
                            {ErrorNome ? <div className="col">
                                <Messages successMessages={[]} infoMessages={[]} warningMessages={[]} dangerMessages={[{ text: ErrorMessageText2 }]}> </Messages>
                            </div> : ''}
                        </div>
                        <div className="col-2">
                            <Input name={"azcng8A_CN_MIDDLE_NAME_EL"} id='MiddleName' label='Middle Name' value={item.azcng8A_CN_MIDDLE_NAME_EL}
                                inputClass={['mr-5']} event={{ onChange: (e) => handleChange(e, index) }} extraProps={extraProps} />
                        </div>
                        <div className="col-2">
                            <div className="d-flex">
                                
                                <Input name={"azcng8A_CN_LAST_NAME_EL"} id='LastName' label='Last name' value={item.azcng8A_CN_LAST_NAME_EL} error={error}
                                    inputClass={['mr-5']} labelClass={['requiredLabel']} event={{ onChange: (e) => handleChange(e, index) }} extraProps={extraProps} />
                            </div>
                            {ErrorCognome ? <div className="col">
                                <Messages successMessages={[]} infoMessages={[]} warningMessages={[]} dangerMessages={[{ text: ErrorMessageText3 }]}> </Messages>
                            </div> : ''}
                        </div>
                        {((item.azcng8A_CN_FIRST_NAME_EL === '' && item.azcng8A_CN_LAST_NAME_EL === '') && index === 0) ? '' : (<div className="col-4">
                            <button type="button" onClick={!props.review ? () => removeSite(item, index) : undefined}
                                className={!props.review ? "btn btn-primary mb-2 btnRemove mt-4 ml-4" : 'btn btn-primary mb-2 mt-4 ml-4 btnDisabledRemove'}>
                                Delete</button>
                        </div>)}
                    </div>
                    <div className="row">
                        <div className="col-3">
                            <div className="d-flex">
                                
                                <div className="col">
                                    <DatePicker id="datepicker" name={"azcng8A_CN_DATA_NASC_EL"} value={item.azcng8A_CN_DATA_NASC_EL} error={error}
                                       labelClass={['requiredLabel']} event={{ onChange: (e) => handleChangeData2(e, index) }} extraProps={extraProps} label="Date of birth(dd/mm/yyyy)"></DatePicker>
                                </div>
                            </div>
                            {ErrorDate ? <div className="col">
                                <Messages successMessages={[]} infoMessages={[]} warningMessages={[]} dangerMessages={[{ text: ErrorMessageText15 }]}> </Messages>
                            </div> : ''}
                            {ErrorAddS ? <div className="col">
                                <Messages successMessages={[]} infoMessages={[]} warningMessages={[]} dangerMessages={[{ text: 'wrong date' }]}> </Messages>
                            </div> : ''}
                        </div>
                        <div className="col-3 ml-5">
                            <div className="d-flex">
                                
                                <SelectInput id={'sel' + index} name={"azcng8A_CN_SEX_EL"} value={item.azcng8A_CN_SEX_EL} error={error} inputClass={[]} labelClass={['requiredLabel']}
                                    dimension='lg' label='Gender' firstEmptyOption={true} optionList={optionList3} event={{ onChange: (e) => handleChange(e, index) }} extraProps={extraProps} />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-3">
                            <div className="d-flex">
                                
                                <div className="col">
                                    <SelectInput id={'Country' + index} name={"azcng8A_CN_STATO_NASC_EL"} value={item.azcng8A_CN_STATO_NASC_EL} error={error} labelClass={['requiredLabel']}
                                        dimension='lg' label='Country of birth' firstEmptyOption={true} optionList={listaNascitaIndir} inputClass={[]} event={{ onChange: (e) => handleChange(e, index) }} extraProps={extraProps} />
                                </div></div>
                            {ErrorCountryBirth ? <div className="col">
                                <Messages successMessages={[]} infoMessages={[]} warningMessages={[]} dangerMessages={[{ text: ErrorMessageText16 }]}> </Messages>
                            </div> : ''}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-4">
                            <div className="d-flex">
                                
                                <div className="col-9">
                                    <Input id={'Telephone' + index} name={"azcng8A_CN_PHONE_NUM_EL"} type='text' dimension='lg' event={{ onChange: (e) => handleChange(e, index) }} labelClass={['requiredLabel']}
                                        label='Telephone number' value={item.azcng8A_CN_PHONE_NUM_EL} inputClass={['mr-5']} extraProps={extraProps3} error={error} />
                                </div>
                            </div>
                            {ErrorTelefono ? <div className="col">
                                <Messages successMessages={[]} infoMessages={[]} warningMessages={[]} dangerMessages={[{ text: ErrorMessageText }]}> </Messages>
                            </div> : ''}
                        </div>
                        <div className="col-4 mt-4"> <span style={{ 'fontSize': '13px', 'color': 'black', 'marginLeft': '-80px' }}>
                            (place the country code at the beginning, i.e. +39 for Italy)</span></div>
                    </div>
                    <div className="row">
                        <div className="col-3">
                            <div className="d-flex">
                                
                                <div className="col">
                                    <Input id={'E-mail' + index} name={"azcng8A_CN_EMAIL_EL"} type='text' dimension='lg' event={{ onChange: (e) => handleChange(e, index) }}
                                       labelClass={['requiredLabel']} label='E-mail' value={item.azcng8A_CN_EMAIL_EL} inputClass={['mr-5']} extraProps={extraProps} error={error} />
                                </div>
                            </div>
                            {ErrorEmail3 ? <div className="col">
                                <Messages successMessages={[]} infoMessages={[]} warningMessages={[]} dangerMessages={[{ text: ErrorMessageText17 }]}> </Messages>
                            </div> : ''}
                        </div>

                        {/* <div className="col-3">
                            <div className="d-flex">
                                
                                <div className="col">
                                    <Input id={'Confirm' + index} name={"azcng8A_CN_CONFERMA_EMAIL_EL"} type='text' dimension='lg' event={{ onChange: (e) => handleChange(e, index) }}
                                        label='Confirm E-mail' value={item.azcng8A_CN_CONFERMA_EMAIL_EL} inputClass={['mr-5']} labelClass={[]} extraProps={extraProps} error={error} />
                                </div>
                            </div>
                            {ErrorEmail4 ? <div className="col">
                                <Messages successMessages={[]} infoMessages={[]} warningMessages={[]} dangerMessages={[{ text: ErrorMessageText18 }]}> </Messages>
                            </div> : ''}
                        </div> */}
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <div className="d-flex">
                                
                                <div className="col">
                                    <InputHelp id={'Relationship' + index} name={"azcng8A_CN_RELATIONSHIP_EL"} value={item.azcng8A_CN_RELATIONSHIP_EL} dimension='lg' label='Relationship with the company'
                                        error={error} event={{ onChange: (e) => handleChange(e, index) }} extraProps={extraProps2} error={error} labelClass={['requiredLabel']}>
                                    </InputHelp>
                                </div>
                            </div>
                            {ErrorRelationship ? <div className="col">
                                <Messages successMessages={[]} infoMessages={[]} warningMessages={[]} dangerMessages={[{ text: ErrorMessageText19 }]}> </Messages>
                            </div> : ''}
                        </div>
                        <div className="col-2 d-flex align-items-center">
                            <em><span style={{ "font-size": "14px" }}>max 200 characters</span></em>
                        </div>
                    </div>
                </div>
            ))}
            <div className="row d-flex mt-1">
                <div className="col-2" />
                <div className="col-3">
                    <button type="button" onClick={!props.review ? verifyAdd : undefined}
                        className={!props.review ? "btn btn-primary mb-2 btnNew mt-2 ml-5" : 'btn btn-primary mb-2 mt-2 ml-5 btnDisabled'}>
                        Add further contact
                                </button>
                </div>
                {ErrorAdd ?
                    <div className="col-4">
                        <Messages successMessages={[]} infoMessages={[]} warningMessages={[{ text: 'è necessario completare tutti i campi' }]} dangerMessages={[]}> </Messages>
                    </div> : ''}
            </div>
        </>
    );
};

export default ContactInformation;
